/**
 * useOrphanRawdataCount — compteur orphelins Rawdata OK / RFID No (FEAT-RECON-CONTROL-PANEL).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchOrphanRawdataCount } from '../lib/api';

export function useOrphanRawdataCount(batchId: string | undefined) {
  return useQuery({
    queryKey:  ['admin', 'orphan-rawdata-count', batchId],
    queryFn:   () => fetchOrphanRawdataCount(batchId!),
    enabled:   Boolean(batchId),
    staleTime: 30_000,
    retry:     1,
  });
}
